module.exports = __webpack_public_path__ + "img/stock1.6f0825ee.png";